import { render, staticRenderFns } from "./PatientsInCareAdmin.vue?vue&type=template&id=7d10f5b6&"
import script from "./PatientsInCareAdmin.vue?vue&type=script&lang=js&"
export * from "./PatientsInCareAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PatientsInCareAdmin.vue?vue&type=style&index=0&id=7d10f5b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports